import { userInteractionStatusPropsType, } from "../../lib/statusType";
import { outerLayoutMixinPropsType, } from "../../mixins/outerLayout";
export const buttonPropsType = userInteractionStatusPropsType
    .extend(outerLayoutMixinPropsType)
    .complete({
    key: true,
    ref: true,
    id: true,
    className: true,
    _dangerouslyOverrideIconSize: true,
    _internal: true,
    autoFocus: true,
    block: true,
    busy: true,
    children: true,
    icon: true,
    text: true,
    action: true,
    iconPosition: true,
    disabled: true,
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9CdXR0b24vdHlwZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBR0EsT0FBTyxFQUNMLDhCQUE4QixHQUUvQixNQUFNLHNCQUFzQixDQUFDO0FBRTlCLE9BQU8sRUFFTCx5QkFBeUIsR0FDMUIsTUFBTSwwQkFBMEIsQ0FBQztBQXNEbEMsTUFBTSxDQUFDLE1BQU0sZUFBZSxHQUFHLDhCQUE4QjtLQUMxRCxNQUFNLENBQUMseUJBQXlCLENBQUM7S0FDakMsUUFBUSxDQUFjO0lBQ3JCLEdBQUcsRUFBRSxJQUFJO0lBQ1QsR0FBRyxFQUFFLElBQUk7SUFDVCxFQUFFLEVBQUUsSUFBSTtJQUNSLFNBQVMsRUFBRSxJQUFJO0lBQ2YsNEJBQTRCLEVBQUUsSUFBSTtJQUNsQyxTQUFTLEVBQUUsSUFBSTtJQUNmLFNBQVMsRUFBRSxJQUFJO0lBQ2YsS0FBSyxFQUFFLElBQUk7SUFDWCxJQUFJLEVBQUUsSUFBSTtJQUNWLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLElBQUk7SUFDVixJQUFJLEVBQUUsSUFBSTtJQUNWLE1BQU0sRUFBRSxJQUFJO0lBQ1osWUFBWSxFQUFFLElBQUk7SUFDbEIsUUFBUSxFQUFFLElBQUk7Q0FDZixDQUFDLENBQUMifQ==